import React from 'react'
import { FormattedMessage } from 'react-intl'
import messages from './messages'
import SupplierAvailabilityDataTable from './components/SupplierAvailabilityDataTable'
import SupplierTurnaround from 'components/SupplierTurnaround'

const Availability = ({ setCallback = () => {}, match: { params: { supplierId } } }) => {
  return (
    <div>
      <div className="font-medium text-4xl">
        <FormattedMessage {...messages.title } />
      </div>

      <div className="text-gray-700 mt-6 w-full whitespace-pre-line mb-10">
        <FormattedMessage { ...messages.turnaroundSubtitle } />
        <div className='py-4'>
          <SupplierTurnaround
            supplierId={supplierId}
            setCallback={setCallback}
          />
        </div>
      </div>

      <div className="text-gray-700 mt-6 w-full whitespace-pre-line mb-10">
        <FormattedMessage {...messages.subtitle } />
      </div>

      <div className="space-y-4 mt-10">
        <SupplierAvailabilityDataTable setCallback={setCallback} supplierId={supplierId} />
      </div>
    </div>
  )
}

export default Availability
